export enum AuthenticateStatus {
    Valid = 'valid',
    AccountNotFound = 'accountNotFound',
    AccountDisabled = 'accountDisabled',
    AccountLocked = 'accountLocked',
    PasswordExpired = 'passwordExpired',
    ServerError = 'serverError',
    UserFound = 'userFound',
    NotAuthenticated = 'notAuthenticated',
    SessionExpired = 'sessionExpired',
    SessionValid = 'sessionValid',
}